
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as test1gYpOS5lEE8aDLzKFCpuf6ND_45tOoazwhm3EyMvxJqvkMeta } from "/opt/atlassian/pipelines/agent/build/pages/test.vue?macro=true";
import { default as indexzBqfwppCFw9qKDsY09O8_45rH2SJIO28gHr__45_45BLq5_45rIMeta } from "/opt/atlassian/pipelines/agent/build/pages/chats/[id]/index.vue?macro=true";
import { default as galleryEeGgFhkd2jLgdJeNsSz3K7raxIW8oJGSmDwQ2RYx_45y4Meta } from "/opt/atlassian/pipelines/agent/build/pages/chats/[id]/gallery.vue?macro=true";
import { default as chats_45DngeQs89fxi7WIpMS5IbGEF3Qul2Et5hP4Wc_yYqLwMeta } from "/opt/atlassian/pipelines/agent/build/pages/chats.vue?macro=true";
import { default as indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as forgotDA4uICjyG2WtNIE8gglqXIQjmpxdLWTy_iDIXXNpoFUMeta } from "/opt/atlassian/pipelines/agent/build/pages/forgot.vue?macro=true";
import { default as searchkSoZtKisAmQzUryIh0rqXTj4XbHTQQLxHrdvFoxZHgUMeta } from "/opt/atlassian/pipelines/agent/build/pages/search.vue?macro=true";
import { default as signupa_454KIVcUi1rCGNXnMW4kc3Shrduc030eDtNsTCfX9ZgMeta } from "/opt/atlassian/pipelines/agent/build/pages/signup.vue?macro=true";
import { default as uploadi38ukBwy5NczixNg0DXte6ZiyqJ33bSajbtoxATYuUYMeta } from "/opt/atlassian/pipelines/agent/build/pages/upload.vue?macro=true";
import { default as members6OPt1Z0H2TVA_45i_45B3PqVi_JLv_IhVZupXcemjzHVb1wMeta } from "/opt/atlassian/pipelines/agent/build/pages/members.vue?macro=true";
import { default as activityLnkU091_45VQb5obe_45O_T_XolifuydZSkIsdxDeQPKX8QMeta } from "/opt/atlassian/pipelines/agent/build/pages/activity.vue?macro=true";
import { default as paymentsdIjgB8WrlhkJtId79DU8LDfrgdqx1dOmYQqTem5P9eoMeta } from "/opt/atlassian/pipelines/agent/build/pages/payments.vue?macro=true";
import { default as settingsMTdwhnirWK8UrGdxuRdWWF3PaCB9OHg9UoxUBcPKBJ4Meta } from "/opt/atlassian/pipelines/agent/build/pages/settings.vue?macro=true";
import { default as _91id_93w_45eNuJ94HK1J6EAXItkhFwdlrt5Mos8N2mfaCV5v9y8Meta } from "/opt/atlassian/pipelines/agent/build/pages/[username]/[id].vue?macro=true";
import { default as cancelWJ3b4qyW1keMalxE7vRtVUSOj7kfsuUdkwNgSc7BWyoMeta } from "/opt/atlassian/pipelines/agent/build/pages/[username]/subscribe/cancel.vue?macro=true";
import { default as successQg3O8MGEVXeA1b8dzTMJhiKQ8_45vhHtMgff4ZaY50r84Meta } from "/opt/atlassian/pipelines/agent/build/pages/[username]/subscribe/success.vue?macro=true";
import { default as processingmYLS2F6r3IyBpNvcjC7oYF24bpZAxCFNJMNnUaM3h_45sMeta } from "/opt/atlassian/pipelines/agent/build/pages/[username]/subscribe/processing.vue?macro=true";
import { default as _91username_935_458hzgHuqdGXdxSFpCQXf6xxelbL3hDX5mtUWpNrPDcMeta } from "/opt/atlassian/pipelines/agent/build/pages/[username].vue?macro=true";
import { default as _91id_93tzC3nAS37l0gFUsEiVY6Z2L8IOzycmh87JOCDCtNVgEMeta } from "/opt/atlassian/pipelines/agent/build/pages/embed/[id].vue?macro=true";
import { default as onboardingg7B58xle_45x8idEvXDJGbXsAnH3bQ9nX1aRi9V2jQctwMeta } from "/opt/atlassian/pipelines/agent/build/pages/onboarding.vue?macro=true";
import { default as cancel9GExS6UAk7XCjQRQNLfXWBOOrv34whCw_45fkuKnb_45urwMeta } from "/opt/atlassian/pipelines/agent/build/pages/posts/[id]/payment/cancel.vue?macro=true";
import { default as canceljAmvJOaeT2DRs6UfEEaGOUrnA41337IlaV9Wg6kQ3t8Meta } from "/opt/atlassian/pipelines/agent/build/pages/posts/[id]/subscribe/cancel.vue?macro=true";
import { default as successfc_45SwWsXke_45bpGqvT30hEMQR0tiSDbIlU2POcWbWiSwMeta } from "/opt/atlassian/pipelines/agent/build/pages/posts/[id]/subscribe/success.vue?macro=true";
import { default as processing65dzXmTLOp1qRyBEXmVgVW0nmD3hTIX805_EptSRacQMeta } from "/opt/atlassian/pipelines/agent/build/pages/posts/[id]/payment/processing.vue?macro=true";
import { default as processingjMIA5HYVeTAsIw912mr3sEf3dDBqf1sF4JYsWTX0q9EMeta } from "/opt/atlassian/pipelines/agent/build/pages/posts/[id]/subscribe/processing.vue?macro=true";
import { default as _91id_938YQNBtTBUrp1c7_456StoLoppdBcV_B9kYssjWjg4jvBcMeta } from "/opt/atlassian/pipelines/agent/build/pages/posts/[id].vue?macro=true";
import { default as statisticshDP_tkTUsFs6ilksW6A4ZIll2XUaKiS933uQwgDn81AMeta } from "/opt/atlassian/pipelines/agent/build/pages/statistics.vue?macro=true";
import { default as indexoWkl7Pjmmmjtdi8mamd9Tj_Yu83vvFR4bstZWuT4Uf8Meta } from "/opt/atlassian/pipelines/agent/build/pages/login/index.vue?macro=true";
import { default as user_45blockedrAwqYQrl21HrTDjbov9HSBs879JfJy0oy_45G1luvHYt8Meta } from "/opt/atlassian/pipelines/agent/build/pages/user-blocked.vue?macro=true";
import { default as password_45reseti3Cjdbn1FbzZAqGB_knu03tHP7Y3O5A26JVuMSwhVu8Meta } from "/opt/atlassian/pipelines/agent/build/pages/password-reset.vue?macro=true";
import { default as privacy_45policyrX3lJmuTes8vr4aGvCdcqL53Z4_45iggpMvSw2Sfeg1UgMeta } from "/opt/atlassian/pipelines/agent/build/pages/privacy-policy.vue?macro=true";
import { default as analytics_45debugzmU3w3hPb_3N_V7DrBcGHys2gbhUO7s0D1W6o9yjGlwMeta } from "/opt/atlassian/pipelines/agent/build/pages/analytics-debug.vue?macro=true";
import { default as billing_45historyxXL6e70Ju1DI6kHz7QvFciYasHeNKd3FGdXbGcx_ywgMeta } from "/opt/atlassian/pipelines/agent/build/pages/billing-history.vue?macro=true";
import { default as earnings_45history7oPHR3IMYpQJnSnqxr01mujj29mJOWFotDaszMnE664Meta } from "/opt/atlassian/pipelines/agent/build/pages/earnings-history.vue?macro=true";
import { default as _91provider_93zbCWXg5jyMvIv2MJVST4RN5faHWrkty_45N_9pmIOdrrAMeta } from "/opt/atlassian/pipelines/agent/build/pages/login/[provider].vue?macro=true";
import { default as index4gw9SQGEHsWaSQLuumJAcRxUsaWibMTArqVxvPj2EpcMeta } from "/opt/atlassian/pipelines/agent/build/pages/creator-panel/index.vue?macro=true";
import { default as analysisJ2nCcqgvouj4Zf0MjG9ReCpONGVzPMoJhUpNrvNiHlQMeta } from "/opt/atlassian/pipelines/agent/build/pages/creator-panel/analysis.vue?macro=true";
import { default as paymentsp3YW5aPzR8x7vfX5U3_Sf5HeMIq41aHCdRMNzdq5MI8Meta } from "/opt/atlassian/pipelines/agent/build/pages/creator-panel/payments.vue?macro=true";
import { default as affiliatesKGIBJ7YaGgR1yPF4aF_45H5Lqlwwj0j_G_45j8PjKBgdKLAMeta } from "/opt/atlassian/pipelines/agent/build/pages/creator-panel/affiliates.vue?macro=true";
import { default as subscription5Q4ncwogIZg2M6rxxErGZCaEe_U1Uu6Ilc6Qxa8W0oEMeta } from "/opt/atlassian/pipelines/agent/build/pages/creator-panel/subscription.vue?macro=true";
import { default as _91hash_93DmYC1ynuaDJffVddhq_45krOsvHJy7bOCB6UYFXXt4pZ4Meta } from "/opt/atlassian/pipelines/agent/build/pages/email/verify/[user_id]/[hash].vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    meta: test1gYpOS5lEE8aDLzKFCpuf6ND_45tOoazwhm3EyMvxJqvkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/test.vue")
  },
  {
    name: "chats",
    path: "/chats",
    meta: { ...(chats_45DngeQs89fxi7WIpMS5IbGEF3Qul2Et5hP4Wc_yYqLwMeta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/chats.vue"),
    children: [
  {
    name: "chats-id",
    path: ":id()",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/chats/[id]/index.vue")
  },
  {
    name: "chats-id-gallery",
    path: ":id()/gallery",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/chats/[id]/gallery.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    meta: { ...(forgotDA4uICjyG2WtNIE8gglqXIQjmpxdLWTy_iDIXXNpoFUMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/forgot.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/search.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: { ...(signupa_454KIVcUi1rCGNXnMW4kc3Shrduc030eDtNsTCfX9ZgMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/signup.vue")
  },
  {
    name: "upload",
    path: "/upload",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/upload.vue")
  },
  {
    name: "members",
    path: "/members",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/members.vue")
  },
  {
    name: "activity",
    path: "/activity",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/activity.vue")
  },
  {
    name: "payments",
    path: "/payments",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/payments.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/settings.vue")
  },
  {
    name: "username",
    path: "/:username()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[username].vue"),
    children: [
  {
    name: "username-id",
    path: ":id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[username]/[id].vue")
  },
  {
    name: "username-subscribe-cancel",
    path: "subscribe/cancel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[username]/subscribe/cancel.vue")
  },
  {
    name: "username-subscribe-success",
    path: "subscribe/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[username]/subscribe/success.vue")
  },
  {
    name: "username-subscribe-processing",
    path: "subscribe/processing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[username]/subscribe/processing.vue")
  }
]
  },
  {
    name: "embed-id",
    path: "/embed/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/embed/[id].vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: { ...(onboardingg7B58xle_45x8idEvXDJGbXsAnH3bQ9nX1aRi9V2jQctwMeta || {}), ...{"middleware":["auth","not-verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/onboarding.vue")
  },
  {
    name: "posts-id",
    path: "/posts/:id()",
    meta: { ...(_91id_938YQNBtTBUrp1c7_456StoLoppdBcV_B9kYssjWjg4jvBcMeta || {}), ...{"middleware":["verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/posts/[id].vue"),
    children: [
  {
    name: "posts-id-payment-cancel",
    path: "payment/cancel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/posts/[id]/payment/cancel.vue")
  },
  {
    name: "posts-id-subscribe-cancel",
    path: "subscribe/cancel",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/posts/[id]/subscribe/cancel.vue")
  },
  {
    name: "posts-id-subscribe-success",
    path: "subscribe/success",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/posts/[id]/subscribe/success.vue")
  },
  {
    name: "posts-id-payment-processing",
    path: "payment/processing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/posts/[id]/payment/processing.vue")
  },
  {
    name: "posts-id-subscribe-processing",
    path: "subscribe/processing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/posts/[id]/subscribe/processing.vue")
  }
]
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/statistics.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(indexoWkl7Pjmmmjtdi8mamd9Tj_Yu83vvFR4bstZWuT4Uf8Meta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login/index.vue")
  },
  {
    name: "user-blocked",
    path: "/user-blocked",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/user-blocked.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: { ...(password_45reseti3Cjdbn1FbzZAqGB_knu03tHP7Y3O5A26JVuMSwhVu8Meta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password-reset.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/privacy-policy.vue")
  },
  {
    name: "analytics-debug",
    path: "/analytics-debug",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/analytics-debug.vue")
  },
  {
    name: "billing-history",
    path: "/billing-history",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/billing-history.vue")
  },
  {
    name: "earnings-history",
    path: "/earnings-history",
    meta: {"middleware":["auth","verified"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/earnings-history.vue")
  },
  {
    name: "login-provider",
    path: "/login/:provider()",
    meta: { ...(_91provider_93zbCWXg5jyMvIv2MJVST4RN5faHWrkty_45N_9pmIOdrrAMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login/[provider].vue")
  },
  {
    name: "creator-panel",
    path: "/creator-panel",
    meta: { ...(index4gw9SQGEHsWaSQLuumJAcRxUsaWibMTArqVxvPj2EpcMeta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/creator-panel/index.vue")
  },
  {
    name: "creator-panel-analysis",
    path: "/creator-panel/analysis",
    meta: { ...(analysisJ2nCcqgvouj4Zf0MjG9ReCpONGVzPMoJhUpNrvNiHlQMeta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/creator-panel/analysis.vue")
  },
  {
    name: "creator-panel-payments",
    path: "/creator-panel/payments",
    meta: { ...(paymentsp3YW5aPzR8x7vfX5U3_Sf5HeMIq41aHCdRMNzdq5MI8Meta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/creator-panel/payments.vue")
  },
  {
    name: "creator-panel-affiliates",
    path: "/creator-panel/affiliates",
    meta: { ...(affiliatesKGIBJ7YaGgR1yPF4aF_45H5Lqlwwj0j_G_45j8PjKBgdKLAMeta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/creator-panel/affiliates.vue")
  },
  {
    name: "creator-panel-subscription",
    path: "/creator-panel/subscription",
    meta: { ...(subscription5Q4ncwogIZg2M6rxxErGZCaEe_U1Uu6Ilc6Qxa8W0oEMeta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/creator-panel/subscription.vue")
  },
  {
    name: "email-verify-user_id-hash",
    path: "/email/verify/:user_id()/:hash()",
    meta: { ...(_91hash_93DmYC1ynuaDJffVddhq_45krOsvHJy7bOCB6UYFXXt4pZ4Meta || {}), ...{"middleware":["auth","verified"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/email/verify/[user_id]/[hash].vue")
  }
]